export default {
  title: 'Bem-vindo',
  subtitle: 'Inicie sessão para gerir a sua conta e pedidos',
  benefits: {
    earn_points: {
      title: 'Ganhe pontos com cada pedido',
      description: 'Acumule pontos e desbloqueie recompensas exclusivas',
    },
    get_deals: {
      title: 'Receba descontos exclusivos',
      description: 'Use os seus pontos para obter itens grátis',
    },
    redeem_points: {
      title: 'Troque pontos por comida grátis',
      description: 'Aceda a promoções exclusivas para membros',
    },
  },
};
